module.exports = __webpack_public_path__ + "media/images/logo-61c5f316.png";